"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var controllers_1 = require("@wix/social-groups-common/dist/src/controllers");
var Controller_1 = require("../common/Controller");
var GroupsController_1 = require("./GroupsController");
var GroupsPageController = /** @class */ (function (_super) {
    tslib_1.__extends(GroupsPageController, _super);
    function GroupsPageController(controllerConfig, experiments) {
        if (experiments === void 0) { experiments = {}; }
        var _this = _super.call(this, controllerConfig, experiments) || this;
        _this.groupsController = new GroupsController_1.default(controllerConfig, experiments);
        _this.controllers.push(_this.groupsController, new controllers_1.AppToastsController(controllerConfig), new controllers_1.MemberInvitesController(controllerConfig));
        return _this;
    }
    return GroupsPageController;
}(Controller_1.Controller));
exports.GroupsPageController = GroupsPageController;
//# sourceMappingURL=GroupsPageController.js.map